// extracted by mini-css-extract-plugin
module.exports = {"ButtonText":"ToolbarButton_ButtonText__CeXso"};